import { Component, Input, OnInit } from '@angular/core';
import { AdditionalDocs, Main } from 'src/app/core/main/main';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  standalone: false,
})
export class DocumentsComponent implements OnInit {
  @Input() main: Main;
  public additionalDocs: AdditionalDocs[];

  ngOnInit(): void {
    this.additionalDocs =
      this.main.AdditionalDocs && this.main.AdditionalDocs.length
        ? this.main.AdditionalDocs
        : null;
  }
}
